var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeminar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4147CB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14C15 12.8969 15.8969 12 17 12H28C29.1031 12 30 12.8969 30 14V23C30 24.1031 29.1031 25 28 25H20.525C20.1562 24.2031 19.5906 23.5156 18.8875 23H22V22C22 21.4469 22.4469 21 23 21H25C25.5531 21 26 21.4469 26 22V23H28V14H17V15.5344C16.4125 15.1937 15.7281 15 15 15V14ZM15 16C15.394 16 15.7841 16.0776 16.1481 16.2284C16.512 16.3791 16.8427 16.6001 17.1213 16.8787C17.3999 17.1573 17.6209 17.488 17.7716 17.8519C17.9224 18.2159 18 18.606 18 19C18 19.394 17.9224 19.7841 17.7716 20.1481C17.6209 20.512 17.3999 20.8427 17.1213 21.1213C16.8427 21.3999 16.512 21.6209 16.1481 21.7716C15.7841 21.9224 15.394 22 15 22C14.606 22 14.2159 21.9224 13.8519 21.7716C13.488 21.6209 13.1573 21.3999 12.8787 21.1213C12.6001 20.8427 12.3791 20.512 12.2284 20.1481C12.0776 19.7841 12 19.394 12 19C12 18.606 12.0776 18.2159 12.2284 17.8519C12.3791 17.488 12.6001 17.1573 12.8787 16.8787C13.1573 16.6001 13.488 16.3791 13.8519 16.2284C14.2159 16.0776 14.606 16 15 16ZM14.1656 23H15.8313C18.1344 23 20 24.8656 20 27.1656C20 27.625 19.6281 28 19.1656 28H10.8344C10.3719 28 10 27.6281 10 27.1656C10 24.8656 11.8656 23 14.1656 23Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(10 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeminar);
export default __webpack_public_path__ + "static/media/seminar.9f70cb61b5d5fc9055c67f2eb3b09c33.svg";
export { ForwardRef as ReactComponent };